import React from "react";
import "../../css/about/socialLinks.css"
import {YandexDzen, Youtube} from "../utils/Icons";
import Navigation from "../utils/Navigation";
import {useLocation} from "react-router-dom";
import {findElementByLink} from "../utils/siteStructure";
import siteStructure from "../siteStructure.json";
import SeoHelmet from "../utils/seo";
import {useTheme} from "../header/Header";

export const socialLinks = [
    {
        name: "Яндекс Дзен",
        url: "https://dzen.ru/sespel",
        icon: (
            <YandexDzen/>
        ),
    },
    {
        name: "Youtube",
        url: "https://www.youtube.com/channel/UC1Ae6QLpOfBRek-0tdhwjxA",
        icon: (
            <Youtube/>
        ),
    }
];

const SocialLinks = () => {

    const location = useLocation();
    const siteData = findElementByLink(siteStructure, location.pathname)
    const seo = siteData !== null && siteData.seo? siteData.seo : {title:"", description:"", keywords:"", changefreq: 'yearly', priority: 0.4}
    const { theme } = useTheme()

    return (
        <div className={`overlay`}>
            <div className={`complexBack ${theme}`}> </div>

            <Navigation/>

            <SeoHelmet
                title={seo.title}
                description={seo.description}
            />

            <div className="social-body">
                <h1 className={`product-title ${theme}`}>Наши социальные сети</h1>
                <div className="social-links">
                    <div className="icons-container">
                        {socialLinks.map((link) => (
                            <a
                                key={link.name}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                                title={link.name}
                            >
                                {link.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SocialLinks;
